import type { Ingredient as Ing } from "../lib/types";
import { scaleAmount } from "../lib/format";

export function IngredientRow({ ing, ratio = 1 }: { ing: Ing; ratio?: number }) {
  const amt = scaleAmount(ing.base, ratio);
  return (
    <div className="ing-row" data-cat={ing.category} title={ing.category}>
      <div className="amt">
        {amt}
        {ing.unit && <span className="unit">{ing.unit}</span>}
      </div>
      <div>
        <div className="name">{ing.name}</div>
        {ing.note && <div className="note">— {ing.note}</div>}
      </div>
    </div>
  );
}
